import {createTypes} from 'reduxsauce'
// Synchronous actions (no saga required)
const syncTypes = createTypes(` 
  ACCOUNTING_CURRENT_PROVIDER_ATTEMPT
  ACCOUNTING_CURRENT_PROVIDER_FAILURE
  ACCOUNTING_CURRENT_PROVIDER_SUCCESS
  ACCOUNTING_INVOICE_HIDE_POST_REPORT
  ACCOUNTING_INVOICE_POST_ASYNC
  ACCOUNTING_INVOICE_POST_ASYNC_SUCCESS
  ACCOUNTING_INVOICE_SHOW_POST_REPORT
  ACCOUNTING_POST_REPORT_LOADING
  ACCOUNTING_PURCHASE_INVOICE_POST_ASYNC
  ACCOUNTING_PURCHASE_INVOICE_POST_ASYNC_SUCCESS
  ACCOUNTING_SAGE50_PROVIDER_DISABLE_ATTEMPT
  ACCOUNTING_SAGE50_PROVIDER_DISABLE_FAILURE
  ACCOUNTING_SAGE50_PROVIDER_DISABLE_SUCCESS
  ACCOUNTING_SAGE50_PROVIDER_ENABLE_ATTEMPT
  ACCOUNTING_SAGE50_PROVIDER_ENABLE_FAILURE
  ACCOUNTING_SAGE50_PROVIDER_ENABLE_SUCCESS
  ACCOUNT_UPGRADE
  CANCEL_PLAN_FAILURE
  CANCEL_PLAN_SUCCESS
  CLOSE_ENABLE_TFA_DIALOG
  CLOSE_TFA_SETUP
  CONNECTED
  CONNECTED  
  CONTACTGRID_UPDATE_FILTERS
  CONTACTS_ACTIVITIES_UPDATE_FILTERS
  CONTACTS_BULK_SAVE_BEGIN
  CONTACTS_BULK_SAVE_FINISH
  CONTACTS_BULK_SAVE_UPDATE
  CONTACTS_BULK_SUBSCRIBE_CANCEL
  CONTACTS_BULK_SUBSCRIBE_OPEN
  CONTACTS_BULK_SUBSCRIBE_SET_LIST
  CONTACTS_COMPANY_CONTACTS_TOGGLE_DORMANTS
  CONTACTS_CONTACT_UPDATED
  CONTACTS_DESELECT_ALL_INVOICES
  CONTACTS_DOCUMENTS_ADD_FOLDER
  CONTACTS_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX
  CONTACTS_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY
  CONTACTS_DOCUMENTS_SET_SELECTED_SUB_FOLDER
  CONTACTS_INVOICES_UPDATE_FILTERS
  CONTACTS_LOAD_CONTACT_LIST_CATEGORY
  CONTACTS_OPPORTUNITIES_UPDATE_FILTERS
  CONTACTS_QUOTES_UPDATE_FILTERS
  CONTACTS_RECENTS_ADD
  CONTACTS_RECENTS_CLEAR
  CONTACTS_RECENTS_REMOVE
  CONTACTS_RECENTS_SET
  CONTACTS_SEARCH
  CONTACTS_SELECT_ALL_INVOICES
  CONTACTS_SET_COMPANY_FIELDS
  CONTACTS_SET_CONTACT_FIELDS
  CONTACTS_SET_CONTACT_LIST
  CONTACTS_SET_CONTACT_LIST
  CONTACTS_SET_FIELD_SELECT_MODE
  CONTACTS_SET_INDIVIDUAL_FIELDS
  CONTACTS_TOGGLE_COMPANY_FIELD
  CONTACTS_TOGGLE_CONTACT_DETAILS_VISIBILITY
  CONTACTS_TOGGLE_CONTACT_FIELD
  CONTACTS_TOGGLE_FIELD_SELECTOR
  CONTACTS_TOGGLE_INDIVIDUAL_FIELD
  CONTACTS_TOGGLE_SEARCH_DRAWER
  CONTACTS_UPDATE_FILTERS
  CONTACTS_UPDATE_SELECTED_INVOICES
  CONTACT_LISTS_COLLAPSE_CATEGORY
  CONTACT_LISTS_EXPAND_CATEGORY
  CONTACT_LISTS_NEW_BUILDER_LIST
  CONTACT_LISTS_REFRESH_COUNTS
  CONTACT_LISTS_SEARCH
  CONTACT_LISTS_SELECT_CATEGORY
  CONTACT_LISTS_SET_CONTACT_LIST
  CONTACT_LISTS_TOGGLE_HIDDEN_LISTS
  CONTACT_LISTS_UPDATE_BUILDER_LIST
  CONTACT_LISTS_UPDATE_HISTORY_STATS
  CONTACT_LIST_BUILDER_ADD_FILTER
  CONTACT_LIST_BUILDER_CREATE_FILTER
  CONTACT_LIST_BUILDER_CREATE_SUB_FILTER
  CONTACT_LIST_BUILDER_REMOVE_FILTER
  CONTACT_LIST_BUILDER_UPDATE_FILTER
  CONTACT_LIST_BUILDER_UPDATE_FILTERS
  CONTEXT_MENU_SELECT
  DATA_CHECK_CURRENCIES
  DATA_CHECK_FIELDS
  DELIVERIES_DELIVERIES_UPDATE_FILTERS
  DELIVERIES_DELIVERY_DIALOG_ADD_ITEMS
  DELIVERIES_DELIVERY_DIALOG_ADD_OPERATIONS
  DELIVERIES_DELIVERY_DIALOG_CHANGE_TAB
  DELIVERIES_DELIVERY_DIALOG_DELETE_ITEMS
  DELIVERIES_DELIVERY_DIALOG_DELETE_OPERATIONS
  DELIVERIES_DELIVERY_DIALOG_HIDE_OPERATIONS_VALIDITY_WARNING
  DELIVERIES_DELIVERY_DIALOG_SHOW_OPERATIONS_VALIDITY_WARNING
  DELIVERIES_DELIVERY_NOTES_UPDATE_FILTERS
  DELIVERIES_DELIVERY_NOTE_SET_EMAIL_FROM_NAME
  DELIVERIES_DELIVERY_NOTE_SET_EMAIL_REPLY_TO
  DELIVERIES_DOCUMENTS_SET_SELECTED_SUB_FOLDER
  DELIVERIES_HIDE_DELIVERY_DIALOG
  DELIVERIES_QUOTE_SELECTOR_UPDATE_FILTERS
  DELIVERIES_READY_FOR_DELIVERY_UPDATE_FILTERS
  DELIVERIES_SELECT_DELIVERY_DEPARTMENT
  DELIVERIES_SHOW_DELIVERY_DIALOG
  DELIVERIES_UPDATE_CALENDAR_FIELD_ORDER
  DELIVERIES_UPDATE_CALENDAR_SELECTED_DATE
  DELIVERIES_UPDATE_CALENDAR_SELECTED_FIELDS
  DELIVERIES_UPDATE_CALENDAR_VIEW_RANGE
  DELIVERIES_UPDATE_DELIVERY_FILTERS
  DELIVERY_NOTE_DIALOG_ADD_ITEMS
  DELIVERY_NOTE_DIALOG_DELETE_ITEMS
  DELIVERY_NOTE_DIALOG_RESET
  DEOBSERVE_COMPANIES
  DEOBSERVE_COMPANY
  DEOBSERVE_CONTACT
  DEOBSERVE_CONTACTS
  DEOBSERVE_DELIVERY
  DEOBSERVE_INVOICE
  DEOBSERVE_JOB_CARDS
  DEOBSERVE_OPPORTUNITIES
  DEOBSERVE_PART
  DEOBSERVE_PURCHASE_INVOICE
  DEOBSERVE_PURCHASE_ORDER
  DEOBSERVE_QUOTE
  DEOBSERVE_SUCCESS
  DIARY_ACTIVITIES_UPDATE_FILTERS
  DIARY_CALENDAR_ACTIVE
  DIARY_CALENDAR_INACTIVE
  DIARY_LIST_ACTIVE
  DIARY_LIST_INACTIVE
  DIARY_ORDERS_UPDATE_FILTERS
  DIARY_UPDATE_ACTIVITY_STATUSES
  DIARY_UPDATE_ACTIVITY_STATUSES_LIST
  DIARY_UPDATE_ACTIVITY_TYPE
  DIARY_UPDATE_ACTIVITY_TYPE_LIST
  DIARY_UPDATE_AGENDA_ACTIVITY_OPTIONS
  DIARY_UPDATE_AGENDA_ACTIVITY_OPTIONS_ORDER
  DIARY_UPDATE_CALENDAR_ACTIVITY_OPTIONS
  DIARY_UPDATE_CALENDAR_ACTIVITY_OPTIONS_ORDER
  DIARY_UPDATE_COMPANIES
  DIARY_UPDATE_COMPANIES_LIST
  DIARY_UPDATE_COMPLETED_ACTIVITIES
  DIARY_UPDATE_COMPLETED_ACTIVITIES_LIST
  DIARY_UPDATE_CONTACTS
  DIARY_UPDATE_CONTACTS_LIST
  DIARY_UPDATE_DIARY_RANGE
  DIARY_UPDATE_DIARY_RANGE_LIST
  DIARY_UPDATE_ORDER_COMPANIES
  DIARY_UPDATE_ORDER_CONTACTS
  DIARY_UPDATE_ORDER_REFERENCES
  DIARY_UPDATE_ORDER_SELECTED_DATE
  DIARY_UPDATE_ORDER_STATE
  DIARY_UPDATE_REFERENCES
  DIARY_UPDATE_REFERENCES_LIST
  DIARY_UPDATE_REJECTED_ACTIVITIES
  DIARY_UPDATE_REJECTED_ACTIVITIES_LIST
  DIARY_UPDATE_SELECTED_DATE
  DIARY_UPDATE_TASK
  DIARY_UPDATE_USERS
  DIARY_UPDATE_USERS_LIST
  DIRTY_CHANGE_ROUTE
  DIRTY_FORM_IS_INVALID
  DIRTY_HIDE_PROMPT
  DIRTY_SET_FORM_VALID
  DIRTY_SET_SAVE_ACTION
  DIRTY_SET_STATUS
  DIRTY_SET_TARGET_ROUTE
  DIRTY_SHOW_PROMPT
  EMAILING_TOGGLE_SEND_COPY_FROM
  GENERAL_ERROR
  GOOGLE_DRIVE_AUTHENTICATE
  GOOGLE_DRIVE_AUTHENTICATE_CALLBACK
  HIDE_ACTIVITY_DIALOG
  HIDE_ADD_BULK_INVOICES_DIALOG
  HIDE_ADD_EXTERNAL_USER_DIALOG
  HIDE_ADD_INVOICE_DIALOG
  HIDE_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG
  HIDE_ADD_PURCHASE_INVOICE_DIALOG
  HIDE_ADD_PURCHASE_ORDER_DIALOG
  HIDE_ADD_QUOTE_DIALOG
  HIDE_ADD_USER_DIALOG
  HIDE_ADD_APPROVAL_DIALOG
  HIDE_ALLOCATE_CONTACT_LIST_DIALOG
  HIDE_CHART_DIALOG
  HIDE_COMPANY_DIALOG
  HIDE_CONTACT_DIALOG
  HIDE_DELETE_DELIVERY_NOTE_FAILURE_PROMPT
  HIDE_DELETE_PART_CATEGORY_DIALOG
  HIDE_DELETE_PARTS_PROMPT
  HIDE_DELIVERY_ACTUAL_TIMES_DIALOG
  HIDE_DELIVERY_NOTE_DIALOG
  HIDE_DELIVERY_TYPE_NOTE_DIALOG
  HIDE_EMAIL_APPROVAL_DIALOG
  HIDE_MARK_PURCHASE_ORDER_PAID_DIALOG
  HIDE_MOVE_PART_CATEGORY_DIALOG
  HIDE_MY_ACCOUNT_PANEL
  HIDE_OPPORTUNITY_DIALOG
  HIDE_PART_USED_IN_PRICING_CALCULATOR_PROMPT
  HIDE_POST_CONTACT_DIALOG
  HIDE_POST_CONTACT_LIST_DIALOG
  HIDE_PRINT_TEMPLATE_DIALOG
  HIDE_VIEW_COMPANY_DIALOG
  HUBSPOT_AUTHENTICATE
  HUBSPOT_AUTHENTICATE_COMPLETE
  INVOICING_BULK_INVOICES_ADD
  INVOICING_ADD_INVOICE_FOR_ORDER
  INVOICING_INVOICE_ADD_INVOICE_ITEM
  INVOICING_INVOICE_ADD_INVOICE_ITEM_AT_INDEX
  INVOICING_INVOICE_COPY_INVOICE_ITEM
  INVOICING_INVOICE_COPY_INVOICE_ITEMS
  INVOICING_INVOICE_DELETE_ALL_INVOICE_ITEMS
  INVOICING_INVOICE_DELETE_INVOICE_ITEM
  INVOICING_INVOICE_DELETE_INVOICE_ITEMS
  INVOICING_INVOICE_DESELECT_ALL_INVOICE_ITEMS
  INVOICING_INVOICE_DESELECT_INVOICE_ITEM
  INVOICING_INVOICE_EDIT_INVOICE_ITEM
  INVOICING_INVOICE_HIDE_ITEM_DRAWER
  INVOICING_INVOICE_PREVIEW_INVOICE
  INVOICING_INVOICE_RECALC_TOTALS
  INVOICING_INVOICE_REMOVE_SELECTED_INVOICE_ITEMS
  INVOICING_INVOICE_REORDER_INVOICE_ITEM
  INVOICING_INVOICE_SELECTOR_LOAD_ITEMS
  INVOICING_INVOICE_SELECTOR_SEARCH
  INVOICING_INVOICE_SELECTOR_TOGGLE_ITEMS
  INVOICING_INVOICE_SELECTOR_UPDATE_FILTERS
  INVOICING_INVOICE_SELECT_ALL_INVOICE_ITEMS
  INVOICING_INVOICE_SELECT_INVOICE_ITEM
  INVOICING_INVOICE_SHOW_ITEM_DRAWER
  INVOICING_INVOICE_TOGGLE_SELECTED_ENTITY
  INVOICING_INVOICE_UPDATE_FILTERS
  INVOICING_INVOICE_UPDATE_INVOICE
  INVOICING_INVOICE_UPDATE_ITEMS
  INVOICING_INVOICE_UPDATE_PROPERTY
  INVOICING_INVOICE_UPDATE_SELECTED_INVOICE_ITEMS
  INVOICING_LOG_CHANGE
  INVOICING_NOT_INVOICED_UPDATE_FILTERS
  INVOICING_PURCHASE_INVOICES_UPDATE_FILTERS
  INVOICING_RECEIVED_NOT_INVOICED_UPDATE_FILTERS
  INVOICING_SELECT_INVOICE
  INVOICING_SET_EMAIL_FROM_NAME
  INVOICING_SET_EMAIL_REPLY_TO
  INVOICING_UNDO_CHANGE
  INVOICING_UNDO_CHANGE_DATA
  INVOICING_UNLOAD_INVOICE
  INVOICING_VIEW_INVOICES_UPDATE_FILTERS
  JOB_CARD_DOCUMENTS_SET_SELECTED_SUB_FOLDER
  LANGUAGE_SET_TARGET
  LANGUAGE_TEXT_TRANSLATED
  LANGUAGE_TRANSLATE_TEXT
  MAILCHIMP_AUTHENTICATE
  MAILCHIMP_AUTHENTICATE_COMPLETE
  NAVIGATION_SELECT_COMPANY
  NAVIGATION_SELECT_CONTACT
  NAVIGATION_SELECT_CONTACT_FOR_COMPANY
  NAVIGATION_SELECT_TAB
  NAVIGATION_SET_SELECTED_CONTACT_TAB
  NAVIGATION_SET_SELECTED_PURCHASING_TAB
  NAVIGATION_SET_SELECTED_QUOTING_TAB
  NOTIFICATION_ACTION
  NOTIFICATION_HIDE
  OBSERVER_PURCHASE_INVOICE_SUCCESS
  OBSERVE_COMPANIES
  OBSERVE_COMPANY
  OBSERVE_CONTACT
  OBSERVE_CONTACTS
  OBSERVE_DELIVERY  
  OBSERVE_INVOICE
  OBSERVE_INVOICE_SUCCESS
  OBSERVE_JOB_CARDS
  OBSERVE_OPPORTUNITIES
  OBSERVE_PART
  OBSERVE_PART_SUCCESS
  OBSERVE_PURCHASE_INVOICE
  OBSERVE_PURCHASE_ORDER
  OBSERVE_PURCHASE_ORDER_SUCCESS
  OBSERVE_QUOTE
  OBSERVE_QUOTE_SUCCESS
  OBSERVE_SUCCESS
  ONBOARDING_ACTIVATE_INFO
  ONBOARDING_ALL_SKILLS_HIDE
  ONBOARDING_ALL_SKILLS_SHOW
  ONBOARDING_DISMISS_INFO
  ONBOARDING_SKILL_FINISH
  ONBOARDING_SKILL_HIDE
  ONBOARDING_SKILL_HINT_DISMISS
  ONBOARDING_SKILL_PAGE
  ONBOARDING_SKILL_SHOW
  ONE_DRIVE_AUTHENTICATE
  ONE_DRIVE_AUTHENTICATE_COMPLETE
  OPEN_ENABLE_TFA_DIALOG
  OPPORTUNITY_SAVE_RECEIVED
  OPPORTUNITY_UPDATE_FILTERS
  PART_CATEGORY_TREE_SELECT_FIELD_SEARCH_PART_CATEGORIES
  PART_CATEGORY_TREE_SELECT_FIELD_SELECT_ALL_PRICE_LISTS
  PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PART_CATEGORY
  PART_CATEGORY_TREE_SELECT_FIELD_SELECT_PRICE_LIST
  PIVOT_TABLE_ADD_ENTITY
  PIVOT_TABLE_ADD_ENTITY_AT_INDEX
  PIVOT_TABLE_CANNOT_SELECT_ROWS
  PIVOT_TABLE_CAN_SELECT_ROWS
  PIVOT_TABLE_CHANGE_SELECTED_ROWS
  PIVOT_TABLE_COPY_ENTITY
  PIVOT_TABLE_DELETE_ENTITY
  PIVOT_TABLE_DESELECT_ALL_ROWS
  PIVOT_TABLE_EDIT_DATA
  PIVOT_TABLE_EDIT_DATA_MULTI
  PIVOT_TABLE_EDIT_ENTITY
  PIVOT_TABLE_EXPORT
  PIVOT_TABLE_EXPORT_FINISH
  PIVOT_TABLE_EXPORT_PROGRESS
  PIVOT_TABLE_EXPORT_START
  PIVOT_TABLE_NULL_ACTION_DO_NOT_USE
  PIVOT_TABLE_PAGE
  PIVOT_TABLE_PAGE_SIZE_UPDATE
  PIVOT_TABLE_REORDER_ENTITY
  PIVOT_TABLE_REQUEST_DATA
  PIVOT_TABLE_RESET
  PIVOT_TABLE_RESET_LOADED
  PIVOT_TABLE_RESET_PAGE
  PIVOT_TABLE_SAVE_ATTEMPT
  PIVOT_TABLE_SAVE_FAILURE
  PIVOT_TABLE_SAVE_SUCCESS
  PIVOT_TABLE_SEARCH
  PIVOT_TABLE_SELECT_ALL_ROWS
  PIVOT_TABLE_SET_COLUMN_SIZES
  PIVOT_TABLE_SET_ENTITIES
  PIVOT_TABLE_SET_FETCHING
  PIVOT_TABLE_SET_GRID_STRETCH
  PIVOT_TABLE_SET_GROUPS
  PIVOT_TABLE_SET_VISIBILITY
  PIVOT_TABLE_SET_VISIBLE_COLUMNS
  PIVOT_TABLE_SORT
  PIVOT_TABLE_TOGGLE_COLLAPSED_ITEMS
  PIVOT_TABLE_TOGGLE_SELECTED_ENTITY
  PIVOT_TABLE_UPDATE_DATA
  PIVOT_TABLE_UPDATE_FILTERS
  PIVOT_TABLE_UPDATE_PARAMS
  PRICE_LISTS_CHANGE_TOP_LEVEL_PART_CATEGORY
  PRICE_LISTS_CHANGE_USE_COST_BREAKS
  PRICE_LISTS_HIDE_ADD_PACK_DIALOG
  PRICE_LISTS_HIDE_ADD_PART_CATEGORY_DIALOG
  PRICE_LISTS_HIDE_ADD_PART_DIALOG
  PRICE_LISTS_HIDE_ADD_PRICE_LIST_DIALOG
  PRICE_LISTS_HIDE_MOVE_PARTS_DIALOG
  PRICE_LISTS_HIDE_PART_CATEGORY_DIALOG
  PRICE_LISTS_IMPORT_AUTO_DETECT_COLUMNS
  PRICE_LISTS_IMPORT_CHANGE_STEP
  PRICE_LISTS_IMPORT_JOB_COMPLETE
  PRICE_LISTS_IMPORT_UPDATE_FILTERS
  PRICE_LISTS_IMPORT_UPDATE_FILTERS_NO_UPDATE
  PRICE_LISTS_REDIRECT_TO_PART_CATEGORY
  PRICE_LISTS_SELECT_PART
  PRICE_LISTS_SELECT_PART_PACK
  PRICE_LISTS_SELECT_PART_SUPPLIER
  PRICE_LISTS_SHOW_ADD_PACK_DIALOG
  PRICE_LISTS_SHOW_ADD_PART_CATEGORY_DIALOG
  PRICE_LISTS_SHOW_ADD_PART_DIALOG
  PRICE_LISTS_SHOW_ADD_PRICE_LIST_DIALOG
  PRICE_LISTS_SHOW_MOVE_PARTS_DIALOG
  PRICE_LISTS_SHOW_PART_CATEGORY_DIALOG
  PRICE_LISTS_UPDATE_PART_CONTENTS
  PRICE_LISTS_UPDATE_PART_PRICE_BREAKS
  PRINT_TEMPLATES_DELIVERIES_SELECT_PRINT_TEMPLATE_GROUP_ID
  PRINT_TEMPLATES_INVOICE_SELECT_PRINT_TEMPLATE_GROUP_ID
  PRINT_TEMPLATES_PURCHASE_SELECT_PRINT_TEMPLATE_GROUP_ID
  PRINT_TEMPLATES_QUOTE_SELECT_PRINT_TEMPLATE_GROUP_ID
  PRINT_TEMPLATES_UPDATE_DELIVERY_NOTE
  PRINT_TEMPLATES_UPDATE_INVOICE
  PRINT_TEMPLATES_UPDATE_ORDER
  PRINT_TEMPLATES_UPDATE_PURCHASE_ORDER
  PRODUCTION_COLLAPSE_WORK_CENTRE
  PRODUCTION_COLLAPSE_WORK_CENTRES
  PRODUCTION_EXPAND_WORK_CENTRE
  PRODUCTION_EXPAND_WORK_CENTRES
  PRODUCTION_FILTER_JOB_CARDS_FOR_DATE_RANGE
  PRODUCTION_HIDE_BULK_REMOVE_FROM_JOB_BOARD_DIALOG
  PRODUCTION_HIDE_SETUP_JOB_CARD_DIALOG
  PRODUCTION_HIDE_VIEW_JOB_CARD_DIALOG
  PRODUCTION_MAXIMISE_JOB_CARD_DIALOG
  PRODUCTION_RESTORE_JOB_CARD_DIALOG
  PRODUCTION_SELECT_PRODUCTION_DEPARTMENT
  PRODUCTION_SET_CONFIRMED_JOBS
  PRODUCTION_SET_CONFIRMED_JOBS_COUNT
  PRODUCTION_SHOW_BULK_REMOVE_FROM_JOB_BOARD_DIALOG
  PRODUCTION_SHOW_SETUP_JOB_CARD_DIALOG
  PRODUCTION_SHOW_VIEW_JOB_CARD_DIALOG
  PRODUCTION_TOGGLE_JOB_CARD_JOB_ADDRESS_VISIBILITY
  PRODUCTION_UPDATE_CONFIRMED_ORDER_COUNT
  PRODUCTION_UPDATE_JOB_BOARD_FILTERS
  PRODUCTION_UPDATE_JOB_BOARD_LIST_VIEW_FILTERS
  PURCHASE_ORDERS_DOCUMENTS_SET_SELECTED_SUB_FOLDER
  PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_SELECTOR_LOAD_ITEMS
  PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_SELECT_QUOTE
  PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS
  PURCHASING_HIDE_ITEM_DRAWER
  PURCHASING_HIDE_PURCHASE_INVOICE_ITEM_DRAWER
  PURCHASING_LOG_CHANGE
  PURCHASING_PURCHASE_INVOICE_REORDER_PURCHASE_INVOICE_ITEM
  PURCHASING_PURCHASE_ORDER_ADD_ITEMS
  PURCHASING_PURCHASE_ORDER_ADD_ORDER_ITEM
  PURCHASING_PURCHASE_ORDER_ADD_ORDER_ITEM_AT_INDEX
  PURCHASING_PURCHASE_ORDER_CHANGED
  PURCHASING_PURCHASE_ORDER_COPY_ORDER_ITEM
  PURCHASING_PURCHASE_ORDER_COPY_ORDER_ITEMS
  PURCHASING_PURCHASE_ORDER_DELETE_ORDER_ITEM
  PURCHASING_PURCHASE_ORDER_DELETE_ORDER_ITEMS
  PURCHASING_PURCHASE_ORDER_DESELECT_ALL_ORDER_ITEMS
  PURCHASING_PURCHASE_ORDER_DESELECT_ORDER_ITEM
  PURCHASING_PURCHASE_ORDER_DOCUMENTS_ADD_FOLDER
  PURCHASING_PURCHASE_ORDER_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX
  PURCHASING_PURCHASE_ORDER_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY
  PURCHASING_PURCHASE_ORDER_DOCUMENTS_UPDATE_FILTERS
  PURCHASING_PURCHASE_ORDER_EDIT_ORDER_ITEM
  PURCHASING_PURCHASE_ORDER_FINDER_SELECT_ORDER
  PURCHASING_PURCHASE_ORDER_FINDER_TOGGLE_ITEMS
  PURCHASING_PURCHASE_ORDER_FINDER_UPDATE_FILTERS
  PURCHASING_PURCHASE_ORDER_LOAD_DOCUMENTS
  PURCHASING_PURCHASE_ORDER_MOVE
  PURCHASING_PURCHASE_ORDER_RECALC_TOTALS
  PURCHASING_PURCHASE_ORDER_REMOVE_SELECTED_ORDER_ITEMS
  PURCHASING_PURCHASE_ORDER_REORDER_ORDER_ITEM
  PURCHASING_PURCHASE_ORDER_SAVE_ADVISORIES
  PURCHASING_PURCHASE_ORDER_SAVE_RECEIVED
  PURCHASING_PURCHASE_ORDER_SELECT_ALL_ORDER_ITEMS
  PURCHASING_PURCHASE_ORDER_SELECT_ORDER_ITEM
  PURCHASING_PURCHASE_ORDER_SET_DISCOUNT_PC
  PURCHASING_PURCHASE_ORDER_SET_TAX_CODE
  PURCHASING_PURCHASE_ORDER_TOGGLE_SELECTED_ENTITY
  PURCHASING_PURCHASE_ORDER_UPDATE_FILTERS 
  PURCHASING_PURCHASE_ORDER_UPDATE_ITEMS
  PURCHASING_PURCHASE_ORDER_UPDATE_PROPERTY
  PURCHASING_PURCHASE_ORDER_UPDATE_SELECTED_ORDER_ITEMS
  PURCHASING_SELECT_PURCHASE_INVOICE
  PURCHASING_SELECT_PURCHASE_ORDER
  PURCHASING_SET_DETAILS_TAB
  PURCHASING_SET_EMAIL_FROM_NAME
  PURCHASING_SET_EMAIL_REPLY_TO
  PURCHASING_SET_SELECTED_CONTACT
  PURCHASING_SHOW_ITEM_DRAWER
  PURCHASING_SHOW_PURCHASE_INVOICE_ITEM_DRAWER
  PURCHASING_UNDO_CHANGE
  PURCHASING_UNDO_CHANGE_DATA
  PURCHASING_UNLOAD_PURCHASE_INVOICE
  PURCHASING_UNLOAD_PURCHASE_ORDER
  QUICK_BOOKS_AUTHENTICATE
  QUICK_BOOKS_AUTHENTICATE_COMPLETE  
  QUOTING_ACTIVITIES_UPDATE_FILTERS
  QUOTING_AMENDMENTS_UPDATE_FILTERS
  QUOTING_APPROVAL_SELECTOR_UPDATE_FILTERS
  QUOTING_DASHBOARD_RELOAD
  QUOTING_DOCUMENTS_ADD_FOLDER
  QUOTING_DOCUMENTS_REMOVE_FOLDER
  QUOTING_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX
  QUOTING_DOCUMENTS_SET_CURRENT_FOLDER
  QUOTING_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY
  QUOTING_DOCUMENTS_SET_PARENT_FOLDER
  QUOTING_DOCUMENTS_SET_ROOT_FOLDER
  QUOTING_DOCUMENTS_SET_SELECTED_SUB_FOLDER
  QUOTING_HIDE_APPROVAL_DRAWER
  QUOTING_HIDE_APPROVAL_REVISIONS_DRAWER
  QUOTING_HIDE_BULK_CLOSE_QUOTES_DIALOG
  QUOTING_INJECT_SELECTED_QUOTE_ITEMS
  QUOTING_INVOICES_UPDATE_FILTERS
  QUOTING_ITEMS_UPDATE_FILTERS
  QUOTING_LOG_CHANGE
  QUOTING_PREPARE_CONTEXT
  QUOTING_PRICE_LIST_ADD_ENTITIES
  QUOTING_PURCHASING_UPDATE_FILTERS
  QUOTING_QUOTE_ADD_ORDER_ITEM
  QUOTING_QUOTE_ADD_ORDER_ITEM_AT_INDEX
  QUOTING_QUOTE_AUTO_EDIT_MODE
  QUOTING_QUOTE_CANCEL_EDIT
  QUOTING_QUOTE_CANNOT_SELECT_ROWS
  QUOTING_QUOTE_CAN_SELECT_ROWS
  QUOTING_QUOTE_CHANGED
  QUOTING_QUOTE_COPY_ORDER_ITEM
  QUOTING_QUOTE_COPY_ORDER_ITEMS
  QUOTING_QUOTE_DELETE_ORDER_ITEM
  QUOTING_QUOTE_DELETE_ORDER_ITEMS
  QUOTING_QUOTE_DESELECT_ALL_ORDER_ITEMS
  QUOTING_QUOTE_DESELECT_ORDER_ITEM
  QUOTING_QUOTE_EDIT_MODE
  QUOTING_QUOTE_EDIT_ORDER_ITEM
  QUOTING_QUOTE_FINDER_INITIALISE_DIALOG
  QUOTING_QUOTE_FINDER_SELECT_QUOTE
  QUOTING_QUOTE_HIDE_ITEM_DRAWER
  QUOTING_QUOTE_MOVE_ORDER
  QUOTING_QUOTE_PREVIEW_QUOTE
  QUOTING_QUOTE_RECALC_TOTALS
  QUOTING_QUOTE_REORDER_ORDER_ITEM
  QUOTING_QUOTE_SAVE_ADVISORIES
  QUOTING_QUOTE_SAVE_COMPLETE
  QUOTING_QUOTE_SAVE_CONFIRMATION_TIMEOUT
  QUOTING_QUOTE_SAVE_RECEIVED
  QUOTING_QUOTE_SELECTOR_LOAD_ITEMS
  QUOTING_QUOTE_SELECTOR_TOGGLE_ITEMS
  QUOTING_QUOTE_SELECTOR_UPDATE_FILTERS
  QUOTING_QUOTE_SELECT_ALL_ORDER_ITEMS
  QUOTING_QUOTE_SELECT_ORDER_ITEM
  QUOTING_QUOTE_SET_DISCOUNT_PC
  QUOTING_QUOTE_SET_FIXED_MARGIN
  QUOTING_QUOTE_SET_FIXED_PRICE
  QUOTING_QUOTE_SET_PRICE_MODE
  QUOTING_QUOTE_SET_TAX_CODE
  QUOTING_QUOTE_SHOW_ITEM_DRAWER
  QUOTING_QUOTE_SHOW_PRICING_CALCULATOR_DRAWER
  QUOTING_QUOTE_HIDE_PRICING_CALCULATOR_DRAWER
  QUOTING_QUOTE_PRICING_CALCULATOR_DRAWER_PART_LOADED
  PRICING_CALCULATOR_FIELD_MAPPINGS_SET
  PRICING_CALCULATOR_LAST_EXECUTION_SET
  PRICING_CALCULATOR_FORM_CLEAR
  PRICING_CALCULATOR_PART_PRICING_SET
  PRICING_CALCULATOR_RESOURCE_INCLUDE_DORMANT_TOGGLE
  PRICING_CALCULATOR_RESOURCE_TYPE_SELECT
  PRICING_CALCULATOR_RESULT_RESET
  PRICING_CALCULATOR_RUN_CLEAR
  QUOTING_QUOTE_TOGGLE_AMEND_MODE_DISABLE
  QUOTING_QUOTE_TOGGLE_AMEND_MODE_ENABLE
  QUOTING_QUOTE_TOGGLE_COLLAPSED_ITEMS
  QUOTING_QUOTE_TOGGLE_SELECTED_ENTITY
  QUOTING_QUOTE_UPDATE_ITEMS
  QUOTING_QUOTE_UPDATE_ORDER
  QUOTING_QUOTE_UPDATE_PROPERTY
  QUOTING_QUOTE_UPDATE_SELECTED_ORDER_ITEMS
  QUOTING_QUOTE_UPDATE_SUB_ITEM_PRICING
  QUOTING_SELECT_QUOTE
  QUOTING_SET_DETAILS_TAB
  QUOTING_SET_EMAIL_FROM_NAME
  QUOTING_SET_EMAIL_REPLY_TO
  QUOTING_SET_SELECTED_CONTACT
  QUOTING_SHOW_APPROVAL_DRAWER
  QUOTING_SHOW_APPROVAL_DRAWER_FOR_ORDER
  QUOTING_SHOW_APPROVAL_REVISIONS_DRAWER
  QUOTING_SHOW_BULK_CLOSE_QUOTES_DIALOG
  QUOTING_TOGGLE_ACTIVE_CONFIRMED_QUOTES
  QUOTING_TOGGLE_ACTIVE_CREDITED_QUOTES
  QUOTING_TOGGLE_ACTIVE_DELIVERED_QUOTES
  QUOTING_TOGGLE_ACTIVE_DRAFT_QUOTES
  QUOTING_TOGGLE_ACTIVE_EXPIRED_QUOTES_PANEL
  QUOTING_TOGGLE_ACTIVE_EXPIRING_QUOTES_PANEL
  QUOTING_TOGGLE_ACTIVE_INVOICED_QUOTES
  QUOTING_TOGGLE_ACTIVE_IN_DELIVERY_PANEL
  QUOTING_TOGGLE_ACTIVE_IN_PRODUCTION_PANEL
  QUOTING_TOGGLE_ACTIVE_NOT_ACCEPTED_QUOTES_PANEL
  QUOTING_TOGGLE_ACTIVE_PAID_QUOTES
  QUOTING_TOGGLE_ACTIVE_QUOTED_QUOTES
  QUOTING_TOGGLE_ACTIVE_RECENT_QUOTES_PANEL
  QUOTING_TOGGLE_ACTIVE_REJECTED_QUOTES
  QUOTING_TOGGLE_ACTIVE_REQUIRED_SOON_QUOTES_PANEL
  QUOTING_TOGGLE_ACTIVE_UNCONFIRMED_QUOTES_PANEL
  QUOTING_TOGGLE_ACTIVE_UNSENT_QUOTES_PANEL
  QUOTING_TOGGLE_OPEN_CONFIRMED_QUOTES
  QUOTING_TOGGLE_OPEN_CREDITED_QUOTES
  QUOTING_TOGGLE_OPEN_DELIVERED_QUOTES
  QUOTING_TOGGLE_OPEN_DRAFT_QUOTES
  QUOTING_TOGGLE_OPEN_EXPIRED_QUOTES_PANEL
  QUOTING_TOGGLE_OPEN_EXPIRING_QUOTES_PANEL
  QUOTING_TOGGLE_OPEN_INVOICED_QUOTES
  QUOTING_TOGGLE_OPEN_IN_DELIVERY_PANEL
  QUOTING_TOGGLE_OPEN_IN_PRODUCTION_PANEL
  QUOTING_TOGGLE_OPEN_NOT_ACCEPTED_QUOTES_PANEL
  QUOTING_TOGGLE_OPEN_PAID_QUOTES
  QUOTING_TOGGLE_OPEN_QUOTED_QUOTES
  QUOTING_TOGGLE_OPEN_RECENT_QUOTES_PANEL
  QUOTING_TOGGLE_OPEN_REJECTED_QUOTES
  QUOTING_TOGGLE_OPEN_REQUIRED_SOON_QUOTES_PANEL
  QUOTING_TOGGLE_OPEN_UNCONFIRMED_QUOTES_PANEL
  QUOTING_TOGGLE_OPEN_UNSENT_QUOTES_PANEL
  QUOTING_UNDO_CHANGE
  QUOTING_UNDO_CHANGE_DATA
  QUOTING_UNLOAD_QUOTE
  QUOTING_VIEW_DASHBOARD_UPDATE_FILTERS
  QUOTING_VIEW_QUOTES_UPDATE_FILTERS
  RECEIVED_SOCKET_MESSAGE
  REFRESH_AUTH_TOTP_REQUIRED
  RELOAD_OPPORTUNITY_ON_BOARD
  SALES_LOAD_ALL_LEADS_OPPORTUNITIES
  SALES_LOAD_ALL_SELLING_OPPORTUNITIES
  SALES_LOAD_ALL_WON_OPPORTUNITIES
  SALES_REMOVE_SALES_ANALYSIS_DATA_SOURCE_LAYOUT_PANEL
  SALES_SEARCH_LEADS_OPPORTUNITIES
  SALES_SEARCH_SELLING_OPPORTUNITIES
  SALES_SEARCH_WON_OPPORTUNITIES
  SALES_TOGGLE_DORMANTS
  SALES_TOGGLE_SUCCESS_STATS_LEADS
  SALES_TOGGLE_SUCCESS_STATS_SELLING
  SALES_TOGGLE_SUCCESS_STATS_WON
  SALES_UPDATE_JOB_TYPES
  SALES_UPDATE_LEADS_FILTERS
  SALES_UPDATE_LEADS_OPPORTUNITY
  SALES_UPDATE_SALES_ANALYSIS_DATA_SOURCE_LAYOUT_PANELS
  SALES_UPDATE_SALES_ANALYSIS_DATA_SOURCE_TOGGLE
  SALES_UPDATE_SALES_ANALYSIS_INVOICING_FILTERS
  SALES_UPDATE_SALES_ANALYSIS_INVOICING_IS_OVERRIDING
  SALES_UPDATE_SALES_ANALYSIS_QUOTING_FILTERS
  SALES_UPDATE_SALES_ANALYSIS_QUOTING_IS_OVERRIDING
  SALES_UPDATE_SELLING_FILTERS
  SALES_UPDATE_SELLING_OPPORTUNITY
  SALES_UPDATE_SUCCESS_STATS_FILTERS
  SALES_UPDATE_USER_OR_TEAM
  SALES_UPDATE_WON_FILTERS
  SALES_UPDATE_WON_OPPORTUNITY
  SEARCH_CANCEL
  SEARCH_CLEAR
  SEARCH_FOCUSED
  SEARCH_RESULT_CLICK
  SEARCH_START
  SEARCH_UPDATE_FILTERS
  SETTINGS_ACTIVITY_RESOURCE_TYPE_CLOSE
  SETTINGS_ACTIVITY_RESOURCE_TYPE_OPEN
  SETTINGS_COLLAPSE_TEAM
  SETTINGS_CONTACT_IMPORT_AUTO_DETECT_COLUMNS
  SETTINGS_CONTACT_IMPORT_CHANGE_STEP
  SETTINGS_CONTACT_IMPORT_JOB_COMPLETE
  SETTINGS_CONTACT_IMPORT_UPDATE_FILTERS
  SETTINGS_CURRENCY_FORMAT
  SETTINGS_CURRENCY_PRECISION
  SETTINGS_DATE_FORMAT
  SETTINGS_EXPAND_TEAM
  SETTINGS_LICENCE_SET
  SETTINGS_LOCALE
  SETTINGS_PLAY_NOTIFICATION_SOUND_TOGGLE
  SETTINGS_SEND_AUTOMATIC_REMINDERS_TOGGLE
  SETTINGS_TEAMS_TOGGLE_DORMANTS
  SETTINGS_TIME_FORMAT
  SET_CURRENT_MODULE
  SET_FEATURE_TOGGLES
  SHARE_POINT_AUTHENTICATE
  SHOPIFY_AUTHENTICATE
  SHOPIFY_AUTHENTICATE_COMPLETE
  SHOW_ACTIVITY_DIALOG
  SHOW_ADD_BULK_INVOICES_DIALOG
  SHOW_ADD_EXTERNAL_USER_DIALOG
  SHOW_ADD_INVOICE_DIALOG
  SHOW_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG
  SHOW_ADD_PURCHASE_INVOICE_DIALOG
  SHOW_ADD_PURCHASE_ORDER_DIALOG
  SHOW_ADD_QUOTE_DIALOG
  SHOW_ADD_USER_DIALOG
  SHOW_ADD_APPROVAL_DIALOG
  SHOW_ALLOCATE_CONTACT_LIST_DIALOG
  SHOW_CHART_DIALOG
  SHOW_COMPANY_DIALOG
  SHOW_CONTACT_DIALOG
  SHOW_DELETE_DELIVERY_NOTE_FAILURE_PROMPT
  SHOW_DELETE_PART_CATEGORY_DIALOG
  SHOW_DELETE_PARTS_PROMPT
  SHOW_DELIVERY_ACTUAL_TIMES_DIALOG
  SHOW_DELIVERY_NOTE_DIALOG
  SHOW_DELIVERY_TYPE_NOTE_DIALOG
  SHOW_EMAIL_APPROVAL_DIALOG
  SHOW_MARK_PURCHASE_ORDER_PAID_DIALOG
  SHOW_MOVE_PART_CATEGORY_DIALOG
  SHOW_MY_ACCOUNT_PANEL
  SHOW_OPPORTUNITY_DIALOG
  SHOW_PART_USED_IN_PRICING_CALCULATOR_PROMPT
  SHOW_POST_CONTACT_DIALOG
  SHOW_POST_CONTACT_LIST_DIALOG
  SHOW_PRINT_TEMPLATE_DIALOG
  SHOW_TFA_LOGIN_FORM
  HIDE_TFA_LOGIN_FORM
  SHOW_VIEW_COMPANY_DIALOG
  SHOW_VIEW_COMPANY_DIALOG_FOR_CONTACT
  SNACKBAR_CLEAR
  SNACKBAR_MESSAGE
  OPEN_TFA_SETUP
  STATE_SAVED
  STATE_UNSAVED
  SYNC_WITH_ROUTE
  TFA_CLEAR_ENABLE_ERROR
  TRACK_ROUTE
  UI_NOTIFICATION_DUE
  UI_READY
  UN_TRACK_ROUTES
  UPDATE_ADD_BULK_INVOICES_DIALOG
  UPDATE_ADD_EXTERNAL_USER_DIALOG
  UPDATE_ADD_USER_DIALOG
  UPDATE_LOGIN_PASSWORD
  UPDATE_LOGIN_USERNAME
  UPDATE_SIGN_UP_COMPANY
  UPDATE_SIGN_UP_FULLNAME
  UPDATE_SIGN_UP_PASSWORD
  UPDATE_SIGN_UP_PASSWORD_REPEAT
  UPDATE_SIGN_UP_USERNAME
  USERS_OBSERVING
  USERS_OBSERVING_INVOICE
  USERS_OBSERVING_ORDER
  USERS_OBSERVING_PURCHASE_ORDER
  USERS_OBSERVING_QUOTE
  USERS_UPDATE_USER
  USERS_USER_UPDATED
  VIEW_COMPANY_DIALOG_ACTIVITIES_UPDATE_FILTERS
  VIEW_COMPANY_DIALOG_CHANGE_TAB
  VIEW_COMPANY_DIALOG_DOCUMENTS_ADD_FOLDER  
  VIEW_COMPANY_DIALOG_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX
  VIEW_COMPANY_DIALOG_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY
  VIEW_COMPANY_DIALOG_DOCUMENTS_UPDATE_FILTERS
  VIEW_COMPANY_DIALOG_INVOICES_UPDATE_FILTERS
  VIEW_COMPANY_DIALOG_LOAD_DOCUMENTS
  VIEW_COMPANY_DIALOG_QUOTES_UPDATE_FILTERS
  VIEW_COMPANY_DIALOG_SELECT_CONTACT
  VIEW_MY_ACCOUNT
  WS_CALL_EXCEPTION
  WS_CALL_NOT_FOUND
  WS_NOT_AUTHORISED
  XERO_AUTHENTICATE
  XERO_AUTHENTICATE_COMPLETE
  ZOHO_CHANGE_RANGE_CANCEL
  ZOHO_CHANGE_RANGE_START
  ZOHO_CONNECT_CANCEL
  ZOHO_CONNECT_START
  ZOHO_INITIALIZE_WORKSPACE
  ZOHO_REAUTHORISE_CANCEL
  ZOHO_REAUTHORISE_START
  ZOHO_SET_CONNECT_STEP
  ZOHO_SET_ORGANISATION_ID
  ZOHO_SET_WORKSPACE_ID
`)

// Asynchronous actions (attempt, success, failure)
export const baseAsyncTypes = createTypes(`
  ACCOUNTING_SAGE50_DATA_UPDATE
  ACCOUNTING_SAGE50_PROVIDER_READ
  ACCOUNTING_SAGE50_PROVIDER_UPDATE
  ACCOUNTING_TAX_CODE_READ
  ACCOUNT_PAYMENT_DETAILS_LOAD
  ACTIVATE_USER 
  ACTIVATE_USER_JWT
  ADD_PURCHASE_ORDER_HISTORY
  ALLOCATE_CONTACT_LIST_DIALOG_ALLOCATE_CONTACT_LIST
  APPROVAL_GET_UPLOAD_URL
  AUTHENTICATE_TOTP_LOGIN
  AUTOMATIC_REMINDER_CONFIG_ADD
  AUTOMATIC_REMINDER_CONFIG_DELETE
  AUTOMATIC_REMINDER_CONFIG_READ
  AUTOMATIC_REMINDER_CONFIG_UPDATE
  BILLING_DETAILS_LOAD
  BILLING_DETAILS_UPDATE
  CLEAR_APPROVAL_DOCUMENTS
  CLEAR_APPROVAL_REVISION_DOCUMENTS
  CONFIG_LOAD
  CONTACTS_ACTIVITIES_LOAD
  CONTACTS_BULK_SUBSCRIBE
  CONTACTS_COMPANY_ADD
  CONTACTS_COMPANY_DELETE
  CONTACTS_COMPANY_DORMANT
  CONTACTS_COMPANY_EDIT
  CONTACTS_COMPANY_LIVE
  CONTACTS_CONTACT_ADD
  CONTACTS_CONTACT_DELETE
  CONTACTS_CONTACT_DORMANT
  CONTACTS_CONTACT_EDIT
  CONTACTS_CONTACT_LIVE
  CONTACTS_CONTACT_METHOD_ADD
  CONTACTS_CONTACT_METHOD_DELETE
  CONTACTS_CONTACT_METHOD_EDIT
  CONTACTS_DETAILS_COMPANY_LOAD
  CONTACTS_DETAILS_CONTACT_LOAD
  CONTACTS_DOCUMENTS_DELETE
  CONTACTS_DOCUMENTS_LOAD
  CONTACTS_DOCUMENTS_LOAD_PARENT_FOLDER
  CONTACTS_DOCUMENTS_UPLOAD
  CONTACTS_GET_FIELD_OPTIONS
  CONTACTS_INVOICES_LOAD
  CONTACTS_LOAD_COMPANIES
  CONTACTS_LOAD_COMPANY_DATA_FIELDS
  CONTACTS_LOAD_CONTACTS
  CONTACTS_LOAD_CONTACT_DATA_FIELDS
  CONTACTS_LOAD_CONTACT_LIST
  CONTACTS_LOAD_CONTACT_LISTS
  CONTACTS_LOAD_CONTACT_LIST_CATEGORY
  CONTACTS_LOAD_EXISTING_COMPANIES
  CONTACTS_LOAD_EXISTING_COMPANIES
  CONTACTS_LOAD_EXISTING_COMPANY
  CONTACTS_LOAD_INDIVIDUAL_DATA_FIELDS
  CONTACTS_LOCATION_ADD
  CONTACTS_LOCATION_DELETE
  CONTACTS_LOCATION_EDIT
  CONTACTS_OPPORTUNITIES_LOAD
  CONTACTS_QUOTES_LOAD
  CONTACTS_REMOVE_COMPANY_IMAGE
  CONTACTS_UPLOAD_COMPANY_IMAGE
  CONTACT_LISTS_ADD_CATEGORY
  CONTACT_LISTS_ADD_LIST
  CONTACT_LISTS_BUILDER_REQUERY
  CONTACT_LISTS_DELETE_CATEGORIES
  CONTACT_LISTS_DELETE_LIST
  CONTACT_LISTS_DORMANT_CONTACTS
  CONTACT_LISTS_GET_TOTAL
  CONTACT_LISTS_LOAD_FILTER_VALUES
  CONTACT_LISTS_LOAD_LIST
  CONTACT_LISTS_REQUERY_LISTS
  CONTACT_LISTS_UPDATE_CATEGORY
  CONTACT_LISTS_UPDATE_LIST
  CUSTOMER_APPROVALS_LOAD
  CUSTOMER_APPROVAL_UPDATE_STATUS
  DATA_BILLING_INVOICES_LOAD
  DATA_CREATE_TEXT_TEMPLATE
  DATA_HOME_COMPANY_LOCATIONS_LOAD
  DATA_LOAD_ACCOUNT_PACKAGES
  DATA_LOAD_ACTIVITY_REASONS
  DATA_LOAD_ACTIVITY_RESOURCES
  DATA_LOAD_ACTIVITY_RESOURCE_TYPES
  DATA_LOAD_ACTIVITY_TYPES
  DATA_LOAD_BUSINESS_TYPES
  DATA_LOAD_BUSINESS_TYPES
  DATA_LOAD_CAMPAIGNS
  DATA_LOAD_CAMPAIGN_GROUPS
  DATA_LOAD_COMPANY_GROUPS
  DATA_LOAD_COMPANY_GROUSP
  DATA_LOAD_COMPANY_PRODUCTS
  DATA_LOAD_CONTACT_LISTS
  DATA_LOAD_CONTACT_LIST_CATEGORIES
  DATA_LOAD_COUNTRIES
  DATA_LOAD_CURRENCIES
  DATA_LOAD_DELIVERY_METHODS
  DATA_LOAD_DELIVERY_RETURN_REASONS
  DATA_LOAD_HOME_CONTACTS
  DATA_LOAD_HOME_CONTACTS
  DATA_LOAD_NOMINAL_CODES
  DATA_LOAD_NOTIFICATIONS
  DATA_LOAD_ORDER_REASONS
  DATA_LOAD_ORDER_TYPES
  DATA_LOAD_PACKAGES
  DATA_LOAD_PACK_TYPES
  DATA_LOAD_PRODUCTION_REASONS
  DATA_LOAD_PRODUCTS
  DATA_LOAD_PURCHASING_DATA_FIELDS
  DATA_LOAD_PURCHASING_ITEM_DATA_FIELDS
  DATA_LOAD_QUOTE_ITEM_DATA_FIELDS
  DATA_LOAD_QUOTING_DATA_FIELDS
  DATA_LOAD_SEND_ADDRESSES
  DATA_LOAD_SHOP_INVOICES
  DATA_LOAD_TAX_CODES
  DATA_LOAD_TEXT_TEMPLATES
  DATA_OPPORTUNITY_STAGES_LOAD
  DELETE_DELIVERY_ACTUAL_TIME
  DELETE_LAYOUT
  DELIVERIES_ADD_DELIVERY
  DELIVERIES_ADD_DELIVERY_ACTUAL_TIME
  DELIVERIES_ADD_DELIVERY_NOTE
  DELIVERIES_CREATE_DELIVERY_TYPE_NOTE
  DELIVERIES_DELETE_DELIVERY
  DELIVERIES_DELETE_DELIVERY_NOTE
  DELIVERIES_DELETE_DELIVERY_TYPE_NOTE
  DELIVERIES_DELIVERY_DIALOG_INITIALISE
  DELIVERIES_DEPARTMENTS_LOAD
  DELIVERIES_LOAD_DELIVERIES
  DELIVERIES_LOAD_DELIVERY
  DELIVERIES_LOAD_DELIVERY_COUNTS
  DELIVERIES_LOAD_DELIVERY_NOTES
  DELIVERIES_LOAD_DELIVERY_NOTE_ITEMS
  DELIVERIES_MARK_AS_DELIVERED
  DELIVERIES_MOVE_DELIVERY
  DELIVERIES_SEND_EMAIL
  DELIVERIES_UPDATE_DELIVERY
  DELIVERIES_UPDATE_DELIVERY_ACTUAL_TIME
  DELIVERIES_UPDATE_DELIVERY_FILTERS
  DELIVERIES_UPDATE_DELIVERY_NOTE
  DELIVERIES_UPDATE_DELIVERY_TYPE_NOTE
  DELIVERIES_WORK_CENTRES_LOAD
  DELIVERY_NOTE_DIALOG_INITIALISE
  DEPARTMENTS_ADD
  DEPARTMENTS_DELETE
  DEPARTMENTS_LOAD
  DEPARTMENTS_UPDATE
  DIALOG_LOAD_ACTIVITY
  DIARY_ADD_ACTIVITY
  DIARY_DELETE_ACTIVITY
  DIARY_EDIT_ACTIVITY
  DIARY_EDIT_ACTIVITY_UPDATE
  DIARY_LOAD_ACTIVITIES
  DIARY_LOAD_ACTIVITIES_LIST
  DIARY_LOAD_ACTIVITY_COUNT
  DIARY_LOAD_ACTIVITY_THREAD
  DIARY_LOAD_ACTIVITY_TYPES
  DIARY_LOAD_ORDERS
  DIARY_LOAD_ORDERS_LIST
  DIARY_MOVE_ACTIVITY
  DISMISS_TFA_PROMPT
  DOCUMENTS_ADD_FOLDER_TEMPLATE
  DOCUMENTS_DELETE_DOCUMENTS
  DOCUMENTS_DELETE_FOLDER_TEMPLATE
  DOCUMENTS_LOAD_BASE_DRIVE
  DOCUMENTS_LOAD_BASE_FOLDER
  DOCUMENTS_LOAD_BASE_SITE
  DOCUMENTS_LOAD_DRIVES
  DOCUMENTS_LOAD_FOLDERS_BY_ID
  DOCUMENTS_LOAD_FOLDER_TEMPLATES
  DOCUMENTS_LOAD_IS_BASE_FOLDER_SET
  DOCUMENTS_LOAD_SITES
  DOCUMENTS_LOAD_UPLOAD_URL
  DOCUMENTS_UPDATE_BASE_DRIVE
  DOCUMENTS_UPDATE_BASE_FOLDER
  DOCUMENTS_UPDATE_BASE_SITE
  DOCUMENTS_UPDATE_FOLDER_TEMPLATE
  DOCUMENTS_UPLOAD_FILE
  EMAILING_CONTACT_LIST_POST
  EMAILING_CONTACT_POST
  EMAILING_OPPORTUNITY_POST
  FORGOT_PASSWORD
  GOOGLE_DRIVE_CHECK_AUTH
  GOOGLE_DRIVE_DEAUTH
  GOOGLE_DRIVE_SET_BASE
  HUBSPOT_DISABLE
  HUBSPOT_ENABLED
  HUBSPOT_LOAD_CONTACT_PROPERTIES
  HUBSPOT_LOAD_LISTS
  HUBSPOT_STATUS
  HUBSPOT_UPDATE_DATA
  INVOICING_INVOICE_ADD
  INVOICING_INVOICE_HISTORY_ADD
  INVOICING_INVOICE_LOAD_HISTORY
  INVOICING_INVOICE_SAVE
  INVOICING_INVOICE_SEND_EMAIL
  INVOICING_INVOICE_UPDATE_FROM_JOB
  INVOICING_INVOICE_UPDATE_INVOICE
  INVOICING_LOAD_BATCH_INVOICES
  INVOICING_LOAD_INVOICE
  INVOICING_LOAD_SUMMARY_INFO
  INVOICING_MARK_POSTED
  INVOICING_UNMARK_POSTED
  LAYOUT_PANEL_ADD
  LAYOUT_PANEL_UPDATE
  LOAD_APPROVAL_DOCUMENTS
  LOAD_APPROVAL_REVISION_DOCUMENTS
  LOAD_LAYOUTS
  LOAD_LAYOUT_PANEL
  LOGIN
  LOGOUT
  MAILCHIMP_DISABLE
  MAILCHIMP_ENABLED
  MAILCHIMP_LOAD_LISTS
  MAILCHIMP_LOAD_MERGE_FIELDS
  MAILCHIMP_STATUS
  NOTIFICATIONS_DISMISS
  NOTIFICATIONS_DISMISS_ALL
  NOTIFICATIONS_LOAD
  NOTIFICATIONS_SNOOZE
  ONE_DRIVE_DISABLE
  ONE_DRIVE_STATUS
  OPPORTUNITY_ADD
  OPPORTUNITY_LOAD
  OPPORTUNITY_UPDATE
  PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PART_CATEGORIES
  PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PART_CATEGORY
  PART_CATEGORY_TREE_SELECT_FIELD_LOAD_PRICE_LISTS
  PAYMENT_METHOD_LOAD
  PAYMENT_METHOD_UPDATE
  PIVOT_TABLE_LOAD
  PRICE_LISTS_ADD_PART
  PRICE_LISTS_ADD_PRICING_TEMPLATE
  PRICE_LISTS_CHECK_DELETE_PARTS
  PRICE_LISTS_DELETE_PARTS
  PRICE_LISTS_DELETE_PRICING_TEMPLATE
  PRICE_LISTS_DUPLICATE_PART
  PRICE_LISTS_IMPORT_JOB_COMMIT
  PRICE_LISTS_IMPORT_JOB_PRECOMMIT
  PRICE_LISTS_IMPORT_JOB_READ
  PRICE_LISTS_IMPORT_JOB_RESET
  PRICE_LISTS_IMPORT_JOB_UPDATE
  PRICE_LISTS_IMPORT_JOB_UPLOAD
  PRICE_LISTS_IMPORT_JOB_VALIDATE
  PRICE_LISTS_LOAD_PART
  PRICE_LISTS_LOAD_PART_CATEGORY
  PRICE_LISTS_LOAD_PRICING_TEMPLATES
  PRICE_LISTS_MOVE_PARTS
  PRICE_LISTS_PACK_ADD
  PRICE_LISTS_PACK_TYPE_ADD
  PRICE_LISTS_PACK_TYPE_DELETE
  PRICE_LISTS_PACK_TYPE_UPDATE
  PRICE_LISTS_PART_CATEGORIES_LOAD
  PRICE_LISTS_PART_CATEGORY_ADD
  PRICE_LISTS_PART_CATEGORY_CHECK_DELETE
  PRICE_LISTS_PART_CATEGORY_DELETE
  PRICE_LISTS_PART_CATEGORY_MOVE
  PRICE_LISTS_PART_CATEGORY_UPDATE
  PRICE_LISTS_PART_PACK_DELETE
  PRICE_LISTS_PART_PRICE_BREAK_ADD
  PRICE_LISTS_PART_QUERY_UPDATE
  PRICE_LISTS_PART_REMOVE_IMAGE
  PRICE_LISTS_PART_SUPPLIER_ADD
  PRICE_LISTS_PART_UPLOAD_IMAGE
  PRICE_LISTS_PRICE_LIST_ADD
  PRICE_LISTS_PRICE_LIST_DELETE
  PRICE_LISTS_PRICE_LIST_LOAD
  PRICE_LISTS_PRICE_LIST_UPDATE
  PRICE_LISTS_PRICING_GROUPS_ADD
  PRICE_LISTS_PRICING_GROUPS_DELETE
  PRICE_LISTS_PRICING_GROUPS_LOAD
  PRICE_LISTS_PRICING_GROUPS_UPDATE
  PRICE_LISTS_UPDATE_PART
  PRICE_LISTS_UPDATE_PRICING_TEMPLATE
  PRICING_CALCULATORS_LOAD
  PRICING_CALCULATOR_FORM_LOAD
  PRICING_CALCULATOR_MASTER_LOAD
  PRICING_CALCULATOR_MASTER_UPDATE
  PRINT_TEMPLATES_ADD_PRINT_TEMPLATE
  PRINT_TEMPLATES_DELETE_PRINT_TEMPLATE
  PRINT_TEMPLATES_DUPLICATE_PRINT_TEMPLATE
  PRINT_TEMPLATES_LOAD_PRINT_TEMPLATE
  PRINT_TEMPLATES_LOAD_PRINT_TEMPLATES
  PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE
  PRODUCTION_ADD_JOB_CARD
  PRODUCTION_ADD_JOB_CARDS
  PRODUCTION_GET_ORDER_COUNT_FOR_BULK_REMOVE
  PRODUCTION_LOAD_CONFIRMED_JOBS
  PRODUCTION_LOAD_CONFIRMED_JOBS_COUNT
  PRODUCTION_LOAD_JOB_CARDS
  PRODUCTION_REMOVE_ORDERS_FROM_JOB_BOARD
  PRODUCTION_REMOVE_ORDER_FROM_JOB_BOARD
  PRODUCTION_UPDATE_JOB_CARD
  PURCHASE_INVOICING_MARK_POSTED
  PURCHASE_INVOICING_UNMARK_POSTED
  PURCHASE_ORDER_MARK_INVOICED
  PURCHASE_ORDER_MARK_RECEIVED
  PURCHASING_ADD_PURCHASE_ORDER
  PURCHASING_LOAD_PURCHASE_INVOICE
  PURCHASING_LOAD_PURCHASE_ORDER
  PURCHASING_LOAD_PURCHASE_ORDER_ACCEPTANCE_URL
  PURCHASING_PURCHASE_INVOICE_ADD
  PURCHASING_PURCHASE_INVOICE_UPDATE
  PURCHASING_PURCHASE_INVOICE_UPDATE_FROM_JOB
  PURCHASING_PURCHASE_ORDER_CHANGE_STATUS  
  PURCHASING_PURCHASE_ORDER_COPY
  PURCHASING_PURCHASE_ORDER_DELETE_DOCUMENTS
  PURCHASING_PURCHASE_ORDER_DOCUMENTS_LOAD_PARENT_FOLDER  
  PURCHASING_PURCHASE_ORDER_SAVE
  PURCHASING_PURCHASE_ORDER_SEND_EMAIL
  PURCHASING_PURCHASE_ORDER_SEND_SIGN_REQUEST
  PURCHASING_PURCHASE_ORDER_UPDATE
  PURCHASING_PURCHASE_ORDER_UPLOAD_DOCUMENTS
  QUICK_BOOKS_DISABLE
  QUICK_BOOKS_ENABLED
  QUICK_BOOKS_NOMINAL_CODES_SYNC
  QUICK_BOOKS_STATUS
  QUICK_BOOKS_UPDATE_ACCOUNT_DATA
  QUOTING_ADD_APPROVAL
  QUOTING_ADD_APPROVAL_REVISION
  QUOTING_BULK_CLOSE_OR_REJECT_ORDERS
  QUOTING_CONTACT_EDIT
  QUOTING_DOCUMENTS_DELETE
  QUOTING_DOCUMENTS_LOAD
  QUOTING_DOCUMENTS_LOAD_PARENT_FOLDER
  QUOTING_DOCUMENTS_UPLOAD
  QUOTING_GET_ORDER_COUNT_FOR_BULK_CLOSE
  QUOTING_LOAD_APPROVAL
  QUOTING_LOAD_APPROVAL_FROM_LIST_VIEW
  QUOTING_LOAD_APPROVAL_CUSTOMER_LINK
  QUOTING_LOAD_EXPIRED_QUOTES
  QUOTING_LOAD_EXPIRING_QUOTES
  QUOTING_LOAD_IN_DELIVERY_QUOTES
  QUOTING_LOAD_IN_PRODUCTION_QUOTES
  QUOTING_LOAD_NOT_ACCEPTED_QUOTES
  QUOTING_LOAD_ORDER_FOR_DELIVERY
  QUOTING_LOAD_QUOTE
  QUOTING_LOAD_QUOTE_AMENDMENTS
  QUOTING_LOAD_QUOTE_ITEMS
  QUOTING_LOAD_QUOTE_STATS
  QUOTING_LOAD_REQUIRED_SOON_QUOTES
  QUOTING_LOAD_REVISIONS
  QUOTING_LOAD_SUMMARY_INFO
  QUOTING_LOAD_UNCONFIRMED_QUOTES
  QUOTING_LOAD_UNSENT_QUOTES
  QUOTING_QUOTE_ADD
  QUOTING_QUOTE_ADD_REVISION
  QUOTING_QUOTE_CHANGE_ORDER_STATUS
  QUOTING_QUOTE_INFO_POPUP_LOAD
  QUOTING_QUOTE_SAVE
  QUOTING_QUOTE_SEND_ACCEPTANCE
  QUOTING_QUOTE_SEND_APPROVAL_EMAIL
  QUOTING_QUOTE_SEND_EMAIL
  QUOTING_QUOTE_UPDATE_ORDER
  QUOTING_SEARCH_FOR_QUOTES
  QUOTING_SET_FOOTER_TEXT
  QUOTING_SET_HEADER_TEXT
  QUOTING_SET_PAYMENT_TERMS
  QUOTING_SET_PRODUCTION_NOTES
  QUOTING_SET_QUOTATION_TERMS
  QUOTING_UNDO_CHANGE
  QUOTING_UPDATE_APPROVAL
  REFRESH_AUTH
  REFRESH_AUTH_TOTP
  RESET_PASSWORD
  SALES_LOAD_LEADS_OPPORTUNITIES
  SALES_LOAD_SELLING_OPPORTUNITIES
  SALES_LOAD_SUCCESS_STATS
  SALES_LOAD_WON_OPPORTUNITIES
  SAVE_LAYOUT
  SEARCH
  SERVICE_HEALTH_LOAD
  SESSION_LOGIN
  SETTINGS_ACTIVITY_RESOURCE_ADD
  SETTINGS_ACTIVITY_RESOURCE_DELETE
  SETTINGS_ACTIVITY_RESOURCE_TYPE_ADD
  SETTINGS_ACTIVITY_RESOURCE_TYPE_DELETE
  SETTINGS_ACTIVITY_RESOURCE_TYPE_UPDATE
  SETTINGS_ACTIVITY_RESOURCE_UPDATE
  SETTINGS_ACTIVITY_TYPE_ADD
  SETTINGS_ACTIVITY_TYPE_DELETE
  SETTINGS_ACTIVITY_TYPE_UPDATE
  SETTINGS_ADD_TEAM
  SETTINGS_ADD_USER
  SETTINGS_AUTH_SETTINGS_READ
  SETTINGS_AUTH_SETTINGS_UPDATE
  SETTINGS_AUTH_USER_SETTINGS_READ
  SETTINGS_CHANGE_PASSWORD
  SETTINGS_CONTACT_IMPORT_JOB_COMMIT
  SETTINGS_CONTACT_IMPORT_JOB_PRECOMMIT
  SETTINGS_CONTACT_IMPORT_JOB_READ
  SETTINGS_CONTACT_IMPORT_JOB_RESET
  SETTINGS_CONTACT_IMPORT_JOB_UPDATE
  SETTINGS_CONTACT_IMPORT_JOB_UPLOAD
  SETTINGS_CONTACT_IMPORT_JOB_VALIDATE
  SETTINGS_CURRENCY_ENABLE
  SETTINGS_CURRENCY_READ
  SETTINGS_CURRENCY_REMOTE_UPDATE
  SETTINGS_CURRENCY_UPDATE
  SETTINGS_DELETE_LOGO
  SETTINGS_DELETE_SIGNATURE
  SETTINGS_DELETE_TEAM
  SETTINGS_GLOBAL_CURRENCY
  SETTINGS_LICENSE_LOAD
  SETTINGS_LOAD_TEAMS
  SETTINGS_LOAD_TEAM_MEMBERS
  SETTINGS_PREFIXES_READ
  SETTINGS_PREFIX_UPDATE
  SETTINGS_REFERRAL_TYPE_APPLY
  SETTINGS_REFERRAL_TYPE_CLEAR
  SETTINGS_REFERRAL_TYPE_READ
  SETTINGS_REMOVE_USER
  SETTINGS_ROLE_ADD
  SETTINGS_ROLE_CHANGE
  SETTINGS_ROLE_CHANGE
  SETTINGS_ROLE_DELETE
  SETTINGS_ROLE_PERMISSION_ADD
  SETTINGS_ROLE_PERMISSION_DELETE
  PRICING_CALCULATOR_ACCESS_TOKEN_CREATE
  PRICING_CALCULATOR_FETCH
  PRICING_CALCULATOR_FORM_FETCH
  PRICING_CALCULATOR_RESOURCES_DORMANT_SET
  PRICING_CALCULATOR_RESOURCES_FORM_FETCH
  PRICING_CALCULATOR_RESOURCES_LOAD
  PRICING_CALCULATOR_RESOURCE_ADD
  PRICING_CALCULATOR_RESOURCE_UPDATE
  PRICING_CALCULATOR_RUN
  PRICING_CALCULATOR_SEND_TO_SUPPORT
  SETTINGS_ROLE_PERMISSION_READ
  SETTINGS_SEND_ACTIVATION_EMAIL
  SETTINGS_SEND_ADDRESS_ADD
  SETTINGS_SEND_ADDRESS_DELETE
  SETTINGS_SEND_ADDRESS_SET_DEFAULT
  SETTINGS_SEND_ADDRESS_VALIDATE
  SETTINGS_SEND_RESET_PASSWORD_EMAIL
  SETTINGS_SEND_TFA_SETUP_EMAIL
  SETTINGS_SUPPORT_TOKENS_ADD
  SETTINGS_SUPPORT_TOKENS_DELETE
  SETTINGS_SUPPORT_TOKENS_READ
  SETTINGS_TAX_CODE_SET_DEFAULT
  SETTINGS_TAX_CODE_UPDATE
  SETTINGS_UPDATE_TEAM
  SETTINGS_UPDATE_TEAM_MEMBER
  SETTINGS_UPDATE_USER
  SETTINGS_UPLOAD_LOGO
  SETTINGS_UPLOAD_SIGNATURE
  SETTINGS_USER_ADD
  SETTINGS_USER_DELETE
  SETTINGS_USER_ROLE_UPDATE
  SETTINGS_USER_SETTINGS_READ
  SETTINGS_USER_SETTINGS_UPDATE
  SETTINGS_USER_SETTING_UPDATE
  SHARE_POINT_DISABLE
  SHARE_POINT_STATUS
  SHOPIFY_DISABLE
  SHOPIFY_DISABLE
  SHOPIFY_ENABLED
  SHOPIFY_ENABLED
  SHOPIFY_STATUS
  SHOPIFY_STATUS
  SIGN_UP
  STATE_LOAD
  STATE_SAVE
  SUBSCRIPTIONS_ADD
  SUBSCRIPTIONS_CANCEL
  SUBSCRIPTIONS_GET_CANCEL_DATE
  SUBSCRIPTIONS_GET_CLIENT_SECRET
  SUBSCRIPTIONS_GET_PRICE
  SUBSCRIPTIONS_LOAD_UPCOMING_INVOICE
  TFA_DISABLE_FOR_ALL
  TFA_ENABLE
  TFA_GET_QR_CODE
  TFA_RESET
  TFA_DISABLE_FOR_USER
  TRUSTED_DEVICES_DELETE
  UPDATE_LAYOUT
  UPDATE_ORDER_HISTORY
  USERFIELDS_ADD
  USERFIELDS_CATEGORY_ADD
  USERFIELDS_CATEGORY_DELETE
  USERFIELDS_CATEGORY_READ
  USERFIELDS_CATEGORY_REORDER
  USERFIELDS_CATEGORY_UPDATE
  USERFIELDS_DELETE
  USERFIELDS_MOVE
  USERFIELDS_READ
  USERFIELDS_REORDER
  USERFIELDS_UPDATE
  USER_DATA_READ
  VIEW_COMPANY_DIALOG_COMPANY_LOAD
  VIEW_COMPANY_DIALOG_CONTACT_LOAD
  VIEW_COMPANY_DIALOG_DELETE_DOCUMENTS
  VIEW_COMPANY_DIALOG_DOCUMENTS_LOAD_PARENT_FOLDER
  VIEW_COMPANY_DIALOG_UPLOAD_DOCUMENTS
  WORK_CENTRES_ADD
  WORK_CENTRES_DELETE
  WORK_CENTRES_LOAD
  WORK_CENTRES_UPDATE
  XERO_DISABLE
  XERO_ENABLED
  XERO_STATUS
  XERO_UPDATE_ACCOUNT_DATA
  ZOHO_ACTIVATE
  ZOHO_AUTHENTICATE
  ZOHO_DEACTIVATE
  ZOHO_GET_ORGANISATIONS
  ZOHO_GET_PLAN
  ZOHO_GET_RECORDS
  ZOHO_GET_SELECTED_TABLES
  ZOHO_GET_WORKSPACES
  ZOHO_STATUS
  ZOHO_SYNC_UPDATE
`)

const expandedAsyncTypes = Object.keys(baseAsyncTypes).map(t => ({
  [t + '_ATTEMPT']: t + '_ATTEMPT',
  [t + '_SUCCESS']: t + '_SUCCESS',
  [t + '_FAILURE']: t + '_FAILURE',
})).reduce((obj, item) => ({...obj, ...item}))


// Define the actions you would like directly sent to the server.
export const socketTypes = createTypes(`
  WS_AUTHENTICATE
  OBSERVE
  DEOBSERVE
  CONNECT
  PING
  DISCONNECT
  DISCONNECTED
`)

const types = {
  ...syncTypes,
  ...expandedAsyncTypes,
  ...socketTypes,
}

// Action types that count as a change to the loaded quote. Defined here (a leaf
// module) rather than in helpers/quotes so it is always initialised before the
// quoting reducers read it during combineReducers() setup.
export const quoteChangeActions = [
  types.QUOTING_QUOTE_UPDATE_PROPERTY,
  types.QUOTING_QUOTE_ADD_ORDER_ITEM,
  types.QUOTING_QUOTE_ADD_ORDER_ITEM_AT_INDEX,
  types.QUOTING_QUOTE_EDIT_ORDER_ITEM,
  types.QUOTING_QUOTE_DELETE_ORDER_ITEM,
  types.QUOTING_QUOTE_DELETE_ORDER_ITEMS,
  types.QUOTING_QUOTE_COPY_ORDER_ITEM,
  types.QUOTING_QUOTE_COPY_ORDER_ITEMS,
  types.QUOTING_QUOTE_REORDER_ORDER_ITEM,
  types.QUOTING_QUOTE_BULK_PRICE_EDITOR_UPDATE_SUPPLIER_DISCOUNT,
  types.QUOTING_QUOTE_BULK_PRICE_EDITOR_UPDATE_MARKUP,
  types.QUOTING_QUOTE_BULK_PRICE_EDITOR_UPDATE_MARGIN,
  types.QUOTING_QUOTE_BULK_PRICE_EDITOR_UPDATE_CUSTOMER_DISCOUNT,
]

export default types
